{
  "b2b-invoice-payment-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e",
    "canonical_url": "https://workspace369.com/research/b2b-invoice-payment-statistics/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/b2b-invoice-payment-statistics/84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e/b2b-invoice-payment-statistics.csv",
        "sha256": "048209d50e59ccab36fdb2548fbf4861662ae67c399d5f5fa17ead6853b52248",
        "bytes": 138640
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/b2b-invoice-payment-statistics/84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e/b2b-invoice-payment-statistics.json",
        "sha256": "0bb6cd0d29ae720a9e30a6c76981c47c34c7a8a3b6cadf16db2989f30c82e1b0",
        "bytes": 228599
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/b2b-invoice-payment-statistics/84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e/b2b-invoice-payment-statistics.bib",
        "sha256": "44d704c7214aefb4c0cc6c88e83dd7a028290d10876379fca4df400f25254b6a",
        "bytes": 546
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/b2b-invoice-payment-statistics/84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e/b2b-invoice-payment-statistics.ris",
        "sha256": "9177bc8dc6d64a3ef3213550fa6be43ab37c75977fefe13cb6766ded62eafddf",
        "bytes": 474
      }
    ],
    "manifest_url": "/downloads/research/versions/b2b-invoice-payment-statistics/84975d4dc14765c9db97e17afa49aeac83e6eaaeb5b229da03556909d5a77f2e/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "small-business-ai-adoption-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85",
    "canonical_url": "https://workspace369.com/research/small-business-ai-adoption-statistics/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/small-business-ai-adoption-statistics/9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85/small-business-ai-adoption-statistics.csv",
        "sha256": "05cb2529b8e488cf754dab7055db743628c10581cc26332057c7455e60cbe3b4",
        "bytes": 156375
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/small-business-ai-adoption-statistics/9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85/small-business-ai-adoption-statistics.json",
        "sha256": "b2f1d1bb0275ab5078d44daf8830046961a232e7ffe3603e69068696e9afa905",
        "bytes": 263372
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/small-business-ai-adoption-statistics/9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85/small-business-ai-adoption-statistics.bib",
        "sha256": "22060b6457475c5986c6f5a1e281ad8262e89a13adcd947a26c8f1bfe37106b3",
        "bytes": 570
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/small-business-ai-adoption-statistics/9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85/small-business-ai-adoption-statistics.ris",
        "sha256": "501ce7fe515ad9677e947e8b7fb16fbf1f0e6630c5a8cd5210ebbc31fa3b6e0b",
        "bytes": 491
      }
    ],
    "manifest_url": "/downloads/research/versions/small-business-ai-adoption-statistics/9fe1beae482382289828a2eb9869e04220c5dd64e6ccb807687a6d7d51c72f85/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "client-work-software-cost-index": {
    "schema_version": "1.0.0",
    "dataset_version": "d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6",
    "canonical_url": "https://workspace369.com/research/client-work-software-cost-index/",
    "evidence_modified": "2026-10-22",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/client-work-software-cost-index/d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6/client-work-software-cost-index.csv",
        "sha256": "d822989fc95873c1c07da54ae86f0ed41d3901bd400c1f7eff73080fecdd6305",
        "bytes": 82247
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/client-work-software-cost-index/d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6/client-work-software-cost-index.json",
        "sha256": "df8d3f93658cce94da9b15acf10e097a85ac153d4d59040112a1446287ef798a",
        "bytes": 129987
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/client-work-software-cost-index/d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6/client-work-software-cost-index.bib",
        "sha256": "2e08e17cc1bb01bb090f191fc02fcf0e49517fcbbc6bc29180efa6fd962b20b6",
        "bytes": 538
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/client-work-software-cost-index/d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6/client-work-software-cost-index.ris",
        "sha256": "f68b485f6fd348683a05c10d4825ddcb935658bf9c20a46aa7502b15eae1a307",
        "bytes": 465
      }
    ],
    "manifest_url": "/downloads/research/versions/client-work-software-cost-index/d2d208d7850b212e50edeb1980562394d1851f7239aade778cc5a10a3a0d62c6/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "professional-services-labor-cost-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93",
    "canonical_url": "https://workspace369.com/research/professional-services-labor-cost-statistics/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/professional-services-labor-cost-statistics/a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93/professional-services-labor-cost-statistics.csv",
        "sha256": "4869379bb5d9cd189b16ac98bac05b7edfca78f9fe50abb1aca8ab9f7025d0e2",
        "bytes": 88256
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/professional-services-labor-cost-statistics/a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93/professional-services-labor-cost-statistics.json",
        "sha256": "2ba64d8864dea074e6e95da029a3f26867160f94bc81e6d86f81482706385acf",
        "bytes": 149985
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/professional-services-labor-cost-statistics/a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93/professional-services-labor-cost-statistics.bib",
        "sha256": "4e1682104e0376ff9dd4295aec5157e01c681649b5ff4f16c8af87bb855b4001",
        "bytes": 568
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/professional-services-labor-cost-statistics/a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93/professional-services-labor-cost-statistics.ris",
        "sha256": "f13014e142e3a484ec35cf0613b24db3bf3b687e2210507c2e5558f824371c0d",
        "bytes": 483
      }
    ],
    "manifest_url": "/downloads/research/versions/professional-services-labor-cost-statistics/a33762f8aee4d68ea48b8178ba340ada643c9e4fdc5c9cd36b00c372e68aac93/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "small-business-survival-rate-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71",
    "canonical_url": "https://workspace369.com/research/small-business-survival-rate-statistics/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/small-business-survival-rate-statistics/f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71/small-business-survival-rate-statistics.csv",
        "sha256": "29c9d85096c1fedc9937f26c5881cf44327fc8e6790cbb2a49e141844f6f67a5",
        "bytes": 72361
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/small-business-survival-rate-statistics/f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71/small-business-survival-rate-statistics.json",
        "sha256": "4b087c49a5a2cf80750d582bbc01a752a20718fb5329377f7a224be84f736714",
        "bytes": 125915
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/small-business-survival-rate-statistics/f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71/small-business-survival-rate-statistics.bib",
        "sha256": "5d39b1a811587f7c6f5ec6a1bcaf10a0b3ca2604c504a22d508d47937c2ae9d1",
        "bytes": 568
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/small-business-survival-rate-statistics/f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71/small-business-survival-rate-statistics.ris",
        "sha256": "24d004b34ef1dee9bb063adcfb9f9bd858d9c6a25075d9af50300cfa02cf6352",
        "bytes": 487
      }
    ],
    "manifest_url": "/downloads/research/versions/small-business-survival-rate-statistics/f02db6de3cf60b84cab02c515e59e202ef17c378dae1c5fb1cd96c4269b49b71/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "small-business-cash-flow-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591",
    "canonical_url": "https://workspace369.com/research/small-business-cash-flow-statistics/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/small-business-cash-flow-statistics/bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591/small-business-cash-flow-statistics.csv",
        "sha256": "cbb5b0b8aaa30579a24ad6e95285605db67f281c44a9f591b6934967839141fd",
        "bytes": 73241
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/small-business-cash-flow-statistics/bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591/small-business-cash-flow-statistics.json",
        "sha256": "6beb54a2f0c57f4d8e7157d65c4079e5cef7679435945f5fe06cfe8f7ee0ae9c",
        "bytes": 115304
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/small-business-cash-flow-statistics/bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591/small-business-cash-flow-statistics.bib",
        "sha256": "fdca50757e1b5ce965124495dc922416d96fe1dd36f27b354e2a4053b14d4e73",
        "bytes": 543
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/small-business-cash-flow-statistics/bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591/small-business-cash-flow-statistics.ris",
        "sha256": "61cb0cefdaa5aa4ffd9e69022670f1488ce027238662ec2c9bfc58718352bdb6",
        "bytes": 466
      }
    ],
    "manifest_url": "/downloads/research/versions/small-business-cash-flow-statistics/bcda37ac1b6ff14d8e84503b028113fcb1e9299fbf84b1b5fb8c641f0b44f591/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "payment-processing-cost-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec",
    "canonical_url": "https://workspace369.com/research/payment-processing-cost-benchmarks/",
    "evidence_modified": "2026-10-22",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/payment-processing-cost-benchmarks/d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec/payment-processing-cost-benchmarks.csv",
        "sha256": "a8215cefb1c8bcc42dd37f894dcf5abbf417c926e98eb6d259f5e24eef3b1854",
        "bytes": 114318
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/payment-processing-cost-benchmarks/d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec/payment-processing-cost-benchmarks.json",
        "sha256": "0a26e4210fba844bf2babd6f134b23ee902c9ba96436a427fc45b06aa36e1ee7",
        "bytes": 189556
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/payment-processing-cost-benchmarks/d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec/payment-processing-cost-benchmarks.bib",
        "sha256": "df140e0e6d1249f5782cdacc4f71dda0060b66a623ae116ca4aeec767c7d17dc",
        "bytes": 554
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/payment-processing-cost-benchmarks/d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec/payment-processing-cost-benchmarks.ris",
        "sha256": "2a97b35d4cc3834a611a29c89510e4e9c27f172640b41ce6c8b3de686d45f1b2",
        "bytes": 478
      }
    ],
    "manifest_url": "/downloads/research/versions/payment-processing-cost-benchmarks/d88e21c5ee49016bef4c12349fafe18f35ed792e536d282e0421bab801c45fec/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "solo-business-revenue-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af",
    "canonical_url": "https://workspace369.com/research/solo-business-revenue-benchmarks/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/solo-business-revenue-benchmarks/5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af/solo-business-revenue-benchmarks.csv",
        "sha256": "da005ffbd9ca260b03775217fce57c2e24c1244fbb6619c3e4f3f9228ef8a599",
        "bytes": 197930
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/solo-business-revenue-benchmarks/5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af/solo-business-revenue-benchmarks.json",
        "sha256": "83062bedac0898a1db98b53cc97c9c542bb7984fe7d0082ccd692c0194e1cb41",
        "bytes": 325169
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/solo-business-revenue-benchmarks/5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af/solo-business-revenue-benchmarks.bib",
        "sha256": "9d9f5275b57a7df56f7afe03e57f8002c290a3c91ab977b7a6ed4a781944e73d",
        "bytes": 551
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/solo-business-revenue-benchmarks/5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af/solo-business-revenue-benchmarks.ris",
        "sha256": "72a45ff8cc83e82a1ec0ba3e3ac588cb1652263f37adce93bcb8dec54b53db94",
        "bytes": 477
      }
    ],
    "manifest_url": "/downloads/research/versions/solo-business-revenue-benchmarks/5099c4e1edc6183cfcdab592691308887cfab5b3ed315323034cc10a82c6a7af/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "sole-proprietor-profit-margin-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289",
    "canonical_url": "https://workspace369.com/research/sole-proprietor-profit-margin-benchmarks/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/sole-proprietor-profit-margin-benchmarks/05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289/sole-proprietor-profit-margin-benchmarks.csv",
        "sha256": "051d6f74137f6ef37efbe92279619d3a7331938cdd3816e380fed7a7a359c893",
        "bytes": 161181
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/sole-proprietor-profit-margin-benchmarks/05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289/sole-proprietor-profit-margin-benchmarks.json",
        "sha256": "9176a7c2788f3ac9925208bfecba82afbf717746a70014a21e71469dcdcf617c",
        "bytes": 258141
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/sole-proprietor-profit-margin-benchmarks/05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289/sole-proprietor-profit-margin-benchmarks.bib",
        "sha256": "5df91d347b4f904b3e93c4283461e89bbd1df9c50e879b0b039a982daba5e6e3",
        "bytes": 578
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/sole-proprietor-profit-margin-benchmarks/05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289/sole-proprietor-profit-margin-benchmarks.ris",
        "sha256": "f4a5d36a91ed897d959427fb3e0a96632d91ae0a0f2b73907cb93a4d27de86f0",
        "bytes": 496
      }
    ],
    "manifest_url": "/downloads/research/versions/sole-proprietor-profit-margin-benchmarks/05ae67c9ad7b3a74f644ca108e83ed5ed71b320e47b1b5fa17ad2b108331c289/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "employee-turnover-statistics-by-industry": {
    "schema_version": "1.0.0",
    "dataset_version": "63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8",
    "canonical_url": "https://workspace369.com/research/employee-turnover-statistics-by-industry/",
    "evidence_modified": "2026-10-29",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/employee-turnover-statistics-by-industry/63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8/employee-turnover-statistics-by-industry.csv",
        "sha256": "46982147946ce2568d990e00ac8bbfc0de2f700e3895f66cfe151e63c3970120",
        "bytes": 76469
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/employee-turnover-statistics-by-industry/63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8/employee-turnover-statistics-by-industry.json",
        "sha256": "5f11933e8e0c7078d1cd0e26128579af118680c60b8d0c9f6ede55bab1e9eb9e",
        "bytes": 132732
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/employee-turnover-statistics-by-industry/63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8/employee-turnover-statistics-by-industry.bib",
        "sha256": "f4248684182f41adca674bd4846ec908a21b18e86cf9e6b2d6ba35f4545e7dcb",
        "bytes": 572
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/employee-turnover-statistics-by-industry/63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8/employee-turnover-statistics-by-industry.ris",
        "sha256": "9058a5f33768910def206f900930a35a863b5c3ec3aec43ad04888a7276e68c0",
        "bytes": 490
      }
    ],
    "manifest_url": "/downloads/research/versions/employee-turnover-statistics-by-industry/63ae16e1b94f656da82ad067ca6226708cf26859a4cf180d340835d62ea5d7a8/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      },
      {
        "date": "2026-10-29",
        "summary": "Answer table for the average turnover rate by industry moved to the top, attrition (quits) answer added, and all 2025 industry values rechecked against the BLS Public Data API. Source observations are unchanged."
      }
    ]
  },
  "sales-productivity-crm-admin-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b",
    "canonical_url": "https://workspace369.com/research/sales-productivity-crm-admin-statistics/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/sales-productivity-crm-admin-statistics/b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b/sales-productivity-crm-admin-statistics.csv",
        "sha256": "3967adce55eb877f0e47dc802c4da3ff6c8e074c6913f6dbd90d61eeb3565a35",
        "bytes": 23650
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/sales-productivity-crm-admin-statistics/b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b/sales-productivity-crm-admin-statistics.json",
        "sha256": "a2da31ddbd632c6ec20b34ce305205bf8ea2d0497b75e77018e391e9c51059e0",
        "bytes": 41101
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/sales-productivity-crm-admin-statistics/b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b/sales-productivity-crm-admin-statistics.bib",
        "sha256": "5ff1d3b147221cea8e103488140ff8a13d0e7d57cdb35638ec7e437b9418fd38",
        "bytes": 559
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/sales-productivity-crm-admin-statistics/b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b/sales-productivity-crm-admin-statistics.ris",
        "sha256": "c453ac263ae5f69f5cc46643a2608895b44d70b080bd214759eeea5ee5085007",
        "bytes": 478
      }
    ],
    "manifest_url": "/downloads/research/versions/sales-productivity-crm-admin-statistics/b74551bc6d4e0bc11907c46bc24df0b26020d5009a0e9a0310e2c3e5cf02166b/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "crm-data-quality-ai-readiness-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed",
    "canonical_url": "https://workspace369.com/research/crm-data-quality-ai-readiness-statistics/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/crm-data-quality-ai-readiness-statistics/eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed/crm-data-quality-ai-readiness-statistics.csv",
        "sha256": "feb6bc0b5b43ee8ce514bf83fe22365e65af1f9b4c3475850b2e5aa0dcdca971",
        "bytes": 16061
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/crm-data-quality-ai-readiness-statistics/eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed/crm-data-quality-ai-readiness-statistics.json",
        "sha256": "5a541f5931af88f71dfe2612d057a3da34404bd01a4669a16fe3bf4fbcbc3f9a",
        "bytes": 28907
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/crm-data-quality-ai-readiness-statistics/eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed/crm-data-quality-ai-readiness-statistics.bib",
        "sha256": "ed97b008266d6ee2a3ef35d0b418513e4cb8456149f3872c214fab119f3193e0",
        "bytes": 557
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/crm-data-quality-ai-readiness-statistics/eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed/crm-data-quality-ai-readiness-statistics.ris",
        "sha256": "b55a6fd13d19d61509eeae8c5c2e46a6b171efb6b85f3a94029339978e85c437",
        "bytes": 475
      }
    ],
    "manifest_url": "/downloads/research/versions/crm-data-quality-ai-readiness-statistics/eadbfb99466af43b1da3b654162bc2b691e37dff33b34ff20930cc4da201e6ed/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "ai-productivity-time-savings-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed",
    "canonical_url": "https://workspace369.com/research/ai-productivity-time-savings-benchmarks/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/ai-productivity-time-savings-benchmarks/1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed/ai-productivity-time-savings-benchmarks.csv",
        "sha256": "cae0c2bad404b7a8cf9f485c309100a305f7fc8034e6357b15e0455adfae50d3",
        "bytes": 16918
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/ai-productivity-time-savings-benchmarks/1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed/ai-productivity-time-savings-benchmarks.json",
        "sha256": "b6cccc47bcb0c78e711d1b4b689c4657f7f9df2a7483013e89b3c1e2748e24f9",
        "bytes": 31779
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/ai-productivity-time-savings-benchmarks/1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed/ai-productivity-time-savings-benchmarks.bib",
        "sha256": "e287e7ab2f841d258e7ede3a010c79b145b1175188567a27e7030db8fffdb1e9",
        "bytes": 554
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/ai-productivity-time-savings-benchmarks/1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed/ai-productivity-time-savings-benchmarks.ris",
        "sha256": "01e13e671e1326a804e3bd11b055e6192c536c663f11a644d54b98183e5e6019",
        "bytes": 473
      }
    ],
    "manifest_url": "/downloads/research/versions/ai-productivity-time-savings-benchmarks/1a57d89d2ab601f957c7e71b8080eeea509994753902e2f79c23a2bf2055caed/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "ai-customer-service-performance-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a",
    "canonical_url": "https://workspace369.com/research/ai-customer-service-performance-statistics/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/ai-customer-service-performance-statistics/9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a/ai-customer-service-performance-statistics.csv",
        "sha256": "561be095a8609cafe39a189e98cd15df2197d56bd16044e2e906b55ac29f121d",
        "bytes": 14369
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/ai-customer-service-performance-statistics/9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a/ai-customer-service-performance-statistics.json",
        "sha256": "e8dd329f9083b37e2903287feeb35429319d2c1daa8d67ccb428f90ad770b50d",
        "bytes": 25158
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/ai-customer-service-performance-statistics/9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a/ai-customer-service-performance-statistics.bib",
        "sha256": "5dea894fc82d1316096176c6392469be318426ff053020c4a82f20761fba44a7",
        "bytes": 559
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/ai-customer-service-performance-statistics/9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a/ai-customer-service-performance-statistics.ris",
        "sha256": "0e3f412a4f9b355a220cfeaa2ca28a920ebc412347ad4dff89c0742731c9cf1f",
        "bytes": 475
      }
    ],
    "manifest_url": "/downloads/research/versions/ai-customer-service-performance-statistics/9b7199d91089625b26a67958da048da846dba2a17dc7b21661dfdd87d970140a/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "workflow-automation-statistics-by-business-function": {
    "schema_version": "1.0.0",
    "dataset_version": "e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254",
    "canonical_url": "https://workspace369.com/research/workflow-automation-statistics-by-business-function/",
    "evidence_modified": "2026-09-12",
    "publication_date": "2026-09-12",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/workflow-automation-statistics-by-business-function/e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254/workflow-automation-statistics-by-business-function.csv",
        "sha256": "6c3a03f2aaee9f19cd63277b636662535a9a44bd709b2182631f873cbbf45d31",
        "bytes": 32149
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/workflow-automation-statistics-by-business-function/e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254/workflow-automation-statistics-by-business-function.json",
        "sha256": "dc1f34289ab5635347b4106d98176d4caaf967cb603712fbf33dbf616920daed",
        "bytes": 52483
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/workflow-automation-statistics-by-business-function/e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254/workflow-automation-statistics-by-business-function.bib",
        "sha256": "da3183b7dd1841dc82e10bee126d1d633cfb8f25f6f2a95ffa50d6ab45001d50",
        "bytes": 586
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/workflow-automation-statistics-by-business-function/e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254/workflow-automation-statistics-by-business-function.ris",
        "sha256": "9e1786c53ff7fa6d97754fd337eab4e3e4f8d1bf8376049965aa05d30b0c8837",
        "bytes": 493
      }
    ],
    "manifest_url": "/downloads/research/versions/workflow-automation-statistics-by-business-function/e367033f18220f621df657f24b110b996eee907a2fe646fdcd6155f5e272c254/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "cloud-software-adoption-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71",
    "canonical_url": "https://workspace369.com/research/cloud-software-adoption-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/cloud-software-adoption-statistics/fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71/cloud-software-adoption-statistics.csv",
        "sha256": "4691c6688c2eb7ff6d47722ec95b89a32058051a213192fb4918d477efdb5811",
        "bytes": 187315
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/cloud-software-adoption-statistics/fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71/cloud-software-adoption-statistics.json",
        "sha256": "c66263272fa582823e06ac0e0c49da92087f3d2a5b7be2b0ceac96f8565faa55",
        "bytes": 298494
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/cloud-software-adoption-statistics/fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71/cloud-software-adoption-statistics.bib",
        "sha256": "979602d4cb30aa786158e89d0382bef97f2eb7c6387abdd8eceff30f985e2862",
        "bytes": 565
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/cloud-software-adoption-statistics/fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71/cloud-software-adoption-statistics.ris",
        "sha256": "6fc659d5f1621fb213f090d6b59d09cba48b392ccbaf338dedc3bf2aff8a0534",
        "bytes": 489
      }
    ],
    "manifest_url": "/downloads/research/versions/cloud-software-adoption-statistics/fa2ef3dcc67c0d8e13b03e2813fa2ad407fa21fe21ea5da44e3dc2c1bb291a71/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "crm-adoption-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71",
    "canonical_url": "https://workspace369.com/research/crm-adoption-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/crm-adoption-statistics/953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71/crm-adoption-statistics.csv",
        "sha256": "a7506fe150192d630effba426684c0049dd4cdb60d7b5be369ca9ad96b7ee6f3",
        "bytes": 182217
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/crm-adoption-statistics/953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71/crm-adoption-statistics.json",
        "sha256": "a26007d2b9ca1417f3a7f200bcc33717a45da8ae26d16747f7bf18dc7e0732af",
        "bytes": 293356
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/crm-adoption-statistics/953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71/crm-adoption-statistics.bib",
        "sha256": "adc4b9be9c78dff68df7e92332ea6e587fbc20df6592584c5b3b934942e3b7df",
        "bytes": 532
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/crm-adoption-statistics/953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71/crm-adoption-statistics.ris",
        "sha256": "b7fdf5f15e22b1d9fb57f6a19c992a72d5727c97396a3bd1cfbf568c9ee47ba7",
        "bytes": 467
      }
    ],
    "manifest_url": "/downloads/research/versions/crm-adoption-statistics/953e9f06b0a0843ceeabbffe2f395c9432bd4318bbd399687175a4c1408e3b71/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "employee-absenteeism-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172",
    "canonical_url": "https://workspace369.com/research/employee-absenteeism-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/employee-absenteeism-statistics/4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172/employee-absenteeism-statistics.csv",
        "sha256": "2e99169cf2cfef606a7ed8f7dcdb0c72a7180049d46eab0991816aa256d14592",
        "bytes": 57595
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/employee-absenteeism-statistics/4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172/employee-absenteeism-statistics.json",
        "sha256": "4b4aa208ee9d08c0eadfd2df40fb694e4ed769bbb54c2cabc995a9b17b7ddacb",
        "bytes": 97235
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/employee-absenteeism-statistics/4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172/employee-absenteeism-statistics.bib",
        "sha256": "dd062b08a9f4ca4a23d880e5a84d1c3f36903a43b8ee9e3973cd8411eefd7811",
        "bytes": 553
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/employee-absenteeism-statistics/4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172/employee-absenteeism-statistics.ris",
        "sha256": "ead8a931b3f9f3e2ce81c793d9e56670da88ed1b3af400316bb735e0a4b822a8",
        "bytes": 480
      }
    ],
    "manifest_url": "/downloads/research/versions/employee-absenteeism-statistics/4d813e493d7cc9522d45ffdb3afa02b292f8f5cb67f7a8360ef56cba23b16172/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "paid-leave-employee-benefits-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d",
    "canonical_url": "https://workspace369.com/research/paid-leave-employee-benefits-benchmarks/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/paid-leave-employee-benefits-benchmarks/4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d/paid-leave-employee-benefits-benchmarks.csv",
        "sha256": "6641a5e0d903b0c2f5a2aad72ea0432e47edf349bad68c40dca60473c4907da6",
        "bytes": 117426
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/paid-leave-employee-benefits-benchmarks/4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d/paid-leave-employee-benefits-benchmarks.json",
        "sha256": "eba0fb8e828f9de6bb2faa03e5cbbf06da5df5a1df571c6c233e80d5a0b4b27a",
        "bytes": 207333
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/paid-leave-employee-benefits-benchmarks/4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d/paid-leave-employee-benefits-benchmarks.bib",
        "sha256": "cc766059228062a81b66b502463f8016b14f3edca86464d5f16683ebe692c103",
        "bytes": 554
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/paid-leave-employee-benefits-benchmarks/4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d/paid-leave-employee-benefits-benchmarks.ris",
        "sha256": "54b055d976c9ebfe533d135b263956dd7a34c4976034608f6f78a454218313d3",
        "bytes": 473
      }
    ],
    "manifest_url": "/downloads/research/versions/paid-leave-employee-benefits-benchmarks/4d74bc89336feb037d3f7973561eefe4a1a0e72c93879731623285091384f93d/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "remote-hybrid-work-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56",
    "canonical_url": "https://workspace369.com/research/remote-hybrid-work-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/remote-hybrid-work-statistics/27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56/remote-hybrid-work-statistics.csv",
        "sha256": "9fdec949a5136a18c19668dd4a017e8ab1c709347aadd810ade6a07140cf3c1a",
        "bytes": 208411
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/remote-hybrid-work-statistics/27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56/remote-hybrid-work-statistics.json",
        "sha256": "4eccc11b6c53c735d9072ae967d1dc7aac4a17da6844a552c0d5958a21b295b4",
        "bytes": 342141
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/remote-hybrid-work-statistics/27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56/remote-hybrid-work-statistics.bib",
        "sha256": "3a95f7befa45d017f811b8325b63d2669c14bd24ee2156b1039a57535f0e116d",
        "bytes": 551
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/remote-hybrid-work-statistics/27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56/remote-hybrid-work-statistics.ris",
        "sha256": "4bfe34be86917fcd5dcc9faf950da15638aa4f72696b9d5cfe993db2a5bf7693",
        "bytes": 480
      }
    ],
    "manifest_url": "/downloads/research/versions/remote-hybrid-work-statistics/27e63b4894edb45dcab3f3c9aab7f69eda181d5ab40e5e372dc16e7de4ae4a56/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "freelancer-independent-contractor-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307",
    "canonical_url": "https://workspace369.com/research/freelancer-independent-contractor-statistics/",
    "evidence_modified": "2026-10-19",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/freelancer-independent-contractor-statistics/33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307/freelancer-independent-contractor-statistics.csv",
        "sha256": "e8a27bc8a4d031e7f1691e9f7ee06450af3ac235c226634dc72ba62aa24aeea0",
        "bytes": 169244
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/freelancer-independent-contractor-statistics/33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307/freelancer-independent-contractor-statistics.json",
        "sha256": "74a8cc7558446aac10c6836750c5017cbd8e36f592cebee628bab8b381c18470",
        "bytes": 299305
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/freelancer-independent-contractor-statistics/33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307/freelancer-independent-contractor-statistics.bib",
        "sha256": "39e0fbf056de90e9493e207d52fd8042681033cc455264c0d92b7e1a3996db1d",
        "bytes": 569
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/freelancer-independent-contractor-statistics/33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307/freelancer-independent-contractor-statistics.ris",
        "sha256": "3e580188b66c6a45665d874d89196aa5d768a6a8594e94737e59fcf1bd5aafd5",
        "bytes": 483
      }
    ],
    "manifest_url": "/downloads/research/versions/freelancer-independent-contractor-statistics/33e691e49f15dbd20cde65c5cc4bf607bc8f96df11635e921f9c54321ab7f307/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      },
      {
        "date": "2026-10-17",
        "summary": "Added the Upwork Freelancing in America and Freelance Forward survey counts (2014–2023), MBO Partners State of Independence counts (2022–2026), the BLS May 2017 and February 2005 contractor figures, a survey-versus-BLS gap section, and archived Freelancers Union and AND.CO figures read in the Internet Archive. The BLS July 2023 values are unchanged."
      },
      {
        "date": "2026-10-19",
        "summary": "Added a one-line answer (11.9 million to 74.9 million, by definition) and MBO Partners’ 2026 statement that full-time independents are 22% of full-time U.S. workers, from its September 28, 2026 release. No 2026 breakdown was estimated; existing figures are unchanged."
      }
    ]
  },
  "new-business-formation-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010",
    "canonical_url": "https://workspace369.com/research/new-business-formation-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/new-business-formation-statistics/466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010/new-business-formation-statistics.csv",
        "sha256": "70252c4cfd5681157943d30be71479fd0a01f8fe9cadf582c5a95d315059dfed",
        "bytes": 232050
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/new-business-formation-statistics/466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010/new-business-formation-statistics.json",
        "sha256": "c90096dcec654df1e6a3549b1023fa45a8d7866dfa07f86ced7e8cb2e0ff4593",
        "bytes": 405863
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/new-business-formation-statistics/466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010/new-business-formation-statistics.bib",
        "sha256": "16d90e4e03b84f06bf3de6af158bcea806c9960eaceb6366839e22e66c59c0cd",
        "bytes": 554
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/new-business-formation-statistics/466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010/new-business-formation-statistics.ris",
        "sha256": "d2f6548026062472147cb6e75d8fcc28765dda629c2e892cea6d2023e65c6d22",
        "bytes": 479
      }
    ],
    "manifest_url": "/downloads/research/versions/new-business-formation-statistics/466a56dbdd879de35524c3b638cef07e17de324ed1d8df60d18590a40758c010/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "business-email-compromise-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc",
    "canonical_url": "https://workspace369.com/research/business-email-compromise-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/business-email-compromise-statistics/f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc/business-email-compromise-statistics.csv",
        "sha256": "321fb8c00b31c685ed30f0c4c61781bd363ebb8194bc458d3301b344c612c084",
        "bytes": 12081
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/business-email-compromise-statistics/f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc/business-email-compromise-statistics.json",
        "sha256": "ce96689859bb79044d838aa1935788d82094b247cb5c290da099f4e022959548",
        "bytes": 23206
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/business-email-compromise-statistics/f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc/business-email-compromise-statistics.bib",
        "sha256": "a42aa8f1520eab2571bfacdbf81d6ba4b84c40c40321afeae22c3409220d3c7f",
        "bytes": 561
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/business-email-compromise-statistics/f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc/business-email-compromise-statistics.ris",
        "sha256": "68d640309be7d4dc29659ba8ba8d6b719235ef28df15e15d79ad9e60aadce68e",
        "bytes": 483
      }
    ],
    "manifest_url": "/downloads/research/versions/business-email-compromise-statistics/f4fd550f0ad79d9e308262fd59e8cecb2e24471f3c39b649d8bbea9d046777bc/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "project-management-success-failure-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9",
    "canonical_url": "https://workspace369.com/research/project-management-success-failure-statistics/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/project-management-success-failure-statistics/57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9/project-management-success-failure-statistics.csv",
        "sha256": "d2cd28ba329379b02a7e1588f05ccbe09f2234895df30725a42b06ca0cf63854",
        "bytes": 16972
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/project-management-success-failure-statistics/57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9/project-management-success-failure-statistics.json",
        "sha256": "213413225882f253f559b52a36d4bb8b6a685150367590dbb2868764369f24ad",
        "bytes": 29294
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/project-management-success-failure-statistics/57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9/project-management-success-failure-statistics.bib",
        "sha256": "0bfacb3212ae82308868ab6cc82f9955e062d721ecbaa67ba689012570e634b6",
        "bytes": 572
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/project-management-success-failure-statistics/57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9/project-management-success-failure-statistics.ris",
        "sha256": "13649d954ed8999d52b563b52e4494baebf6ffec263829a72f0b03e4885bb3b5",
        "bytes": 485
      }
    ],
    "manifest_url": "/downloads/research/versions/project-management-success-failure-statistics/57aff43c57b595908e30d574d72d1af8f3f60c7b05d1a8cb96b46a70edba02e9/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "revenue-per-employee-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a",
    "canonical_url": "https://workspace369.com/research/revenue-per-employee-benchmarks/",
    "evidence_modified": "2026-09-13",
    "publication_date": "2026-09-13",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/revenue-per-employee-benchmarks/d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a/revenue-per-employee-benchmarks.csv",
        "sha256": "cc70015a245779a49a904b6a3fff0aafb1addd9e24c3b999da089fd527eec027",
        "bytes": 59452
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/revenue-per-employee-benchmarks/d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a/revenue-per-employee-benchmarks.json",
        "sha256": "d1a2ee64c15e5e1cfa0f06d5997f8a4c4ceb86b0dcfa2b262fa44eb31ebb1783",
        "bytes": 99533
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/revenue-per-employee-benchmarks/d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a/revenue-per-employee-benchmarks.bib",
        "sha256": "2b45b690703db97e56894750d6456973cb30352ace2c6b34048db248fada44bb",
        "bytes": 546
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/revenue-per-employee-benchmarks/d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a/revenue-per-employee-benchmarks.ris",
        "sha256": "7a0b0f4a728708af2f5cd06969c627cf6f7f19a46f96160927b7a12750ee9ac9",
        "bytes": 473
      }
    ],
    "manifest_url": "/downloads/research/versions/revenue-per-employee-benchmarks/d814a17d9df26758c249ccea148ca892d8216e187cd40ec3fa9dc00d264b3f3a/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "agency-pricing-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749",
    "canonical_url": "https://workspace369.com/research/agency-pricing-benchmarks/",
    "evidence_modified": "2026-10-22",
    "publication_date": "2026-10-08",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/agency-pricing-benchmarks/7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749/agency-pricing-benchmarks.csv",
        "sha256": "19695ef67d966cdc77b989fcd57bd78f41ca86f561bb0e1699971ae7dacd25c1",
        "bytes": 14687
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/agency-pricing-benchmarks/7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749/agency-pricing-benchmarks.json",
        "sha256": "42ecb3bfca8bf5a66cbc08bb45f9217043ccc17595139f2856817dd3342d37a8",
        "bytes": 28720
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/agency-pricing-benchmarks/7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749/agency-pricing-benchmarks.bib",
        "sha256": "ff62531ad89cded7910f8b0cf951091691e3e0e4e9070fceb2d1ec75f935edd8",
        "bytes": 533
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/agency-pricing-benchmarks/7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749/agency-pricing-benchmarks.ris",
        "sha256": "ea97d8eef07a8a790537adf420f4378a84aa6c35e0db2a2e45007d663239fad3",
        "bytes": 466
      }
    ],
    "manifest_url": "/downloads/research/versions/agency-pricing-benchmarks/7a3307d17db1721f517218fe723360c00c9aa661ecc8997de09d320a82432749/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "freelancer-rate-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f",
    "canonical_url": "https://workspace369.com/research/freelancer-rate-benchmarks/",
    "evidence_modified": "2026-10-08",
    "publication_date": "2026-10-08",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/freelancer-rate-benchmarks/6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f/freelancer-rate-benchmarks.csv",
        "sha256": "187a8115bb28e983e7600b4417231a9d135f132287e436558339e5ae6abfc010",
        "bytes": 11657
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/freelancer-rate-benchmarks/6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f/freelancer-rate-benchmarks.json",
        "sha256": "63929d0e7e9285ed8d785b3e083877c684760f214e018ad952cfe7d1d7f349a1",
        "bytes": 21394
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/freelancer-rate-benchmarks/6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f/freelancer-rate-benchmarks.bib",
        "sha256": "ef0e5fd76f862a49805a9e27454f0758a1550989012844e28d7e44784fc25635",
        "bytes": 531
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/freelancer-rate-benchmarks/6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f/freelancer-rate-benchmarks.ris",
        "sha256": "5a81759dbba90d7069056b26fd676eaf83b7bd95cb9ec8acf6eda09989f903ee",
        "bytes": 463
      }
    ],
    "manifest_url": "/downloads/research/versions/freelancer-rate-benchmarks/6478e207d3c4eea1a2be7c67e0262f07bbd1c965e8c6b0d8be8e34a6ced1845f/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "web-design-pricing-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8",
    "canonical_url": "https://workspace369.com/research/web-design-pricing-benchmarks/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-10-09",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/web-design-pricing-benchmarks/13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8/web-design-pricing-benchmarks.csv",
        "sha256": "634e54981658901c8acf8389b85694e8441a7edb021c02606f82e4d890d3036e",
        "bytes": 13424
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/web-design-pricing-benchmarks/13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8/web-design-pricing-benchmarks.json",
        "sha256": "1e20556e1c2ad8ef713faebe99a26166f4cc1c215a9fc9c597da76b4536c4eff",
        "bytes": 25025
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/web-design-pricing-benchmarks/13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8/web-design-pricing-benchmarks.bib",
        "sha256": "0d47b55ad14c891c55f97dc032917fd3b188e7c6b8e3d01ef1d149cef16fdc5a",
        "bytes": 544
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/web-design-pricing-benchmarks/13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8/web-design-pricing-benchmarks.ris",
        "sha256": "c3876f56d2e77bf1b73c2636e05aa88df9bf23469a96e0e8a236e0d807ac86af",
        "bytes": 473
      }
    ],
    "manifest_url": "/downloads/research/versions/web-design-pricing-benchmarks/13d61e05471c6a460a786f94133a71b78ee0f1166ee9cd6c0244880fe8a2a4a8/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "agency-profit-margin-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f",
    "canonical_url": "https://workspace369.com/research/agency-profit-margin-benchmarks/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-10-09",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/agency-profit-margin-benchmarks/a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f/agency-profit-margin-benchmarks.csv",
        "sha256": "6232fb0e8be46fb90d7dfb67ca4ced5097247d79b106e9f0d5d8362d362a08bd",
        "bytes": 12920
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/agency-profit-margin-benchmarks/a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f/agency-profit-margin-benchmarks.json",
        "sha256": "64a9f04ce64510718ac3c192ffb0f64dad151df1c262cea51267b5155a75ced8",
        "bytes": 23940
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/agency-profit-margin-benchmarks/a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f/agency-profit-margin-benchmarks.bib",
        "sha256": "a2327ec08f8e5b1ee3ef8f339b8d8979f211d7eb2b7e0a836974b4cdefaf5114",
        "bytes": 551
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/agency-profit-margin-benchmarks/a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f/agency-profit-margin-benchmarks.ris",
        "sha256": "4289e75d661526c0327e53e5cbc820c58c1de4748f0860e4e157159c1066faf2",
        "bytes": 478
      }
    ],
    "manifest_url": "/downloads/research/versions/agency-profit-margin-benchmarks/a309aba17d4fea4a41b56288c3934d385b14de591ab7f6308381d16b1100366f/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "proposal-close-rate-benchmarks": {
    "schema_version": "1.0.0",
    "dataset_version": "1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62",
    "canonical_url": "https://workspace369.com/research/proposal-close-rate-benchmarks/",
    "evidence_modified": "2026-10-09",
    "publication_date": "2026-10-09",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/proposal-close-rate-benchmarks/1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62/proposal-close-rate-benchmarks.csv",
        "sha256": "82fcdf495e1a4ab39b99f69e90e01b0fd38d64aeffa798027802887997321ed1",
        "bytes": 10680
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/proposal-close-rate-benchmarks/1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62/proposal-close-rate-benchmarks.json",
        "sha256": "4b867891b3ac21f73920a1c2c4f1edfbf473b7072027c6c86df06d0f19e8a409",
        "bytes": 19136
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/proposal-close-rate-benchmarks/1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62/proposal-close-rate-benchmarks.bib",
        "sha256": "e0d36f1149bc55712e2ba6bfed594621aacf31c8231a9eb1fa7a16e7d41c9aef",
        "bytes": 547
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/proposal-close-rate-benchmarks/1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62/proposal-close-rate-benchmarks.ris",
        "sha256": "0c726fdf0fb16b747eb02870509e6ff8c8e9633532917ca45bc9c41942413d09",
        "bytes": 475
      }
    ],
    "manifest_url": "/downloads/research/versions/proposal-close-rate-benchmarks/1f2f4f8016947cb2d4d56752e60cff1525190b6bfe9656128b7bcde9ec601b62/manifest.json",
    "revisions": [
      {
        "date": "2026-10-10",
        "summary": "Versioned CSV and JSON archives, checksums and reference-manager exports added. Source observations and evidence dates are unchanged."
      }
    ]
  },
  "freelancer-late-payment-statistics": {
    "schema_version": "1.0.0",
    "dataset_version": "904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f",
    "canonical_url": "https://workspace369.com/research/freelancer-late-payment-statistics/",
    "evidence_modified": "2026-10-21",
    "publication_date": "2026-10-17",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/freelancer-late-payment-statistics/904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f/freelancer-late-payment-statistics.csv",
        "sha256": "87c2c2f5251b8ee6462b9d38b370e89b884c1a544dcfd129764f08c1b5f57958",
        "bytes": 56842
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/freelancer-late-payment-statistics/904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f/freelancer-late-payment-statistics.json",
        "sha256": "7f6b1a323b9c160e7f64292bbdef8cb85ecdbdd083080e2cd83ddda9cdac3b54",
        "bytes": 100390
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/freelancer-late-payment-statistics/904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f/freelancer-late-payment-statistics.bib",
        "sha256": "e7c3628447b6932f0c0917b8c31f4ee3239c6d6a9788ef78702517485e2e2924",
        "bytes": 566
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/freelancer-late-payment-statistics/904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f/freelancer-late-payment-statistics.ris",
        "sha256": "804fef13a507299b3e6380c2a335f9bc4f394e0e18feffe37c37a0cae1559774",
        "bytes": 490
      }
    ],
    "manifest_url": "/downloads/research/versions/freelancer-late-payment-statistics/904712fe63bcdc2cf31ef3de16cf1ce9f7cf3ff8c827df0b153c06306896e33f/manifest.json",
    "revisions": [
      {
        "date": "2026-10-17",
        "summary": "First publication: Freelancers Union 2015 survey, IPSE 2022, NYC DCWP FY2019–2023 complaint data and the Freelancers Union 2025 campaign tally, each shown separately."
      },
      {
        "date": "2026-10-19",
        "summary": "Added a law tracker (New York City, New York State, Illinois, current UK law and the Commercial Payments Bill) and a complaints section with the UK Small Business Commissioner’s 2024–25 and 2023–24 casework figures, from official sources only. Existing survey and NYC figures are unchanged."
      },
      {
        "date": "2026-10-21",
        "summary": "Updated the Commercial Payments Bill row: the House of Lords held third reading on October 20, 2026 and the bill goes to the House of Commons next, per UK Parliament’s bill record. No other figures changed."
      }
    ]
  },
  "freelance-writing-rates": {
    "schema_version": "1.0.0",
    "dataset_version": "6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62",
    "canonical_url": "https://workspace369.com/research/freelance-writing-rates/",
    "evidence_modified": "2026-10-17",
    "publication_date": "2026-10-17",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/freelance-writing-rates/6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62/freelance-writing-rates.csv",
        "sha256": "36f034a93435e9449ac3be63eabd09e528f3ebecca393a707b181b2e7f7c7243",
        "bytes": 62514
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/freelance-writing-rates/6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62/freelance-writing-rates.json",
        "sha256": "777ebd7a6723f7cfee07f26eaa4c1b5813f512b5375c49fb610232456269e314",
        "bytes": 100214
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/freelance-writing-rates/6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62/freelance-writing-rates.bib",
        "sha256": "986c36bdfa21b5d8a9a0b2a3bc54aef9aa223c0b3bc8a9df664e33c5c5361beb",
        "bytes": 545
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/freelance-writing-rates/6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62/freelance-writing-rates.ris",
        "sha256": "5fc68fd7e79f608759cb5a9a929cb6cbc8522288e3710cc315268eecad29bbd5",
        "bytes": 480
      }
    ],
    "manifest_url": "/downloads/research/versions/freelance-writing-rates/6d59cf2e4dff99453bbc3f40d5bf629991a00e1227aacd8a4abe7a583be34c62/manifest.json",
    "revisions": [
      {
        "date": "2026-10-17",
        "summary": "First publication: Editorial Freelancers Association 2026 Rate Chart (2025 rates) for writing and editing, with BLS May 2025 employee wages shown separately."
      }
    ]
  },
  "client-work-software-price-tracker": {
    "schema_version": "1.0.0",
    "dataset_version": "bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a",
    "canonical_url": "https://workspace369.com/research/client-work-software-price-tracker/",
    "evidence_modified": "2026-10-21",
    "publication_date": "2026-10-21",
    "archive_introduced": "2026-10-10",
    "license": "https://workspace369.com/downloads/research/license-v1.html",
    "files": [
      {
        "format": "csv",
        "url": "/downloads/research/versions/client-work-software-price-tracker/bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a/client-work-software-price-tracker.csv",
        "sha256": "e8a170b604beea23741f63fcbbecc49c25ea3169d55ae1e31e173f88f95eb27a",
        "bytes": 41620
      },
      {
        "format": "json",
        "url": "/downloads/research/versions/client-work-software-price-tracker/bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a/client-work-software-price-tracker.json",
        "sha256": "934755dc553f6965027805f42668cc4a549989a1fc34c59d31d59b5bbc43cc94",
        "bytes": 78014
      },
      {
        "format": "bib",
        "url": "/downloads/research/versions/client-work-software-price-tracker/bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a/client-work-software-price-tracker.bib",
        "sha256": "c5dd98d5b38a11304b263adc7c5ea0f1c06202b1dd8172a25bde84348f239194",
        "bytes": 572
      },
      {
        "format": "ris",
        "url": "/downloads/research/versions/client-work-software-price-tracker/bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a/client-work-software-price-tracker.ris",
        "sha256": "e739735ab6aed6531fef893b7ee7dad932a48ceb21d2be341f11dd8a3303ff5b",
        "bytes": 496
      }
    ],
    "manifest_url": "/downloads/research/versions/client-work-software-price-tracker/bca705120ae6a55e0dc176468ef4cd0cdc5a58134457094628779d7be5476d9a/manifest.json",
    "revisions": [
      {
        "date": "2026-10-20",
        "summary": "First publication: plan prices for eight client-work tools, each read on the vendor’s pricing page with both billing views, plus a change log from archived vendor pages (HoneyBook February 2025, Dubsado December 2025)."
      }
    ]
  }
}
